













































































































































































import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, institutionServer, performanceServer } from '@/api/installServer';
import AddCheck from '@/views/inspectionContents/checklist/unit/addCheck.vue';
import CheckingPage from '@/views/inspectionContents/checklist/unit/checkingPage.vue';
import ViewIt from '@/views/inspectionContents/checklist/unit/viewIt.vue';
import showDetail from '@/views/inspectionContents/checklist/unit/showDetail.vue';
import EditProp from '@/views/inspectionContents/checklist/unit/editProp.vue';
import { arrayToTree } from '@/util/arrayToTree';
import Axios from 'axios';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

@Component({
  components: { PagingUnit, AddCheck, CheckingPage, ViewIt, showDetail, EditProp },
  mixins: [TableStripe],
  filters: {},
})
export default class Checklist extends Vue {
  rowId: any = {};
  pageFlag = 0;
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0;
  loadingTable = false;
  formData: any = {
    receiptCode: '', // 单据编号
    startCheckDate: '',
    endCheckDate: '',
    inspectedUnitId: '', // 被检单位id列表
    checkBigCategory: '', // 检查大类
    checkLevel: '', // 检查级别
    checkType: '', // 检查类型
    hazardContent: '', // 检查类型
    self: false, // 与我相关
  };
  tableData: any = [];
  userId: any = '';
  subSpaceByAuthOptions: any = []; // 部门数组
  checkBigCategoryOption: any = []; // 检查类别
  checkLevelOption: any = []; // 检查级别

  exportLoading = false; // 导出的加载
  multipleSelection: Array<any> = []; // 选中的列表

  created() {
    this.getCheckBigCategoryOption();
    this.getCheckTypeOption();
    const userInfo: any = localStorage.getItem('userInfo');
    this.userId = JSON.parse(userInfo).userId;
  }

  mounted() {
    this.getSubSpaceByAuth();
    this.getList();
  }

  private getList() {
    this.loadingTable = true;
    performanceServer
      .getList(this.getListQueryParam())
      .then((res: any) => {
        this.loadingTable = false;
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.loadingTable = false;
        this.$message.error('获取数据失败');
        throw error;
      });
  }

  // 检查大类
  private getCheckBigCategoryOption() {
    dictServe.getDetailsMapByName('securityCheckBigCategory').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            label: res.data[key],
            value: key,
          });
        }
        this.checkBigCategoryOption = helpArr;
      } else {
        this.$message.warning('获取检查大类选项数据失败！');
      }
    });
  }

  // 检查类型
  private getCheckTypeOption() {
    dictServe.getDetailsMapByName('securityCheckType').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            label: res.data[key],
            value: key,
          });
        }
        this.checkLevelOption = helpArr;
      } else {
        this.$message.warning('获取检查类型选项数据失败！');
      }
    });
  }

  // 部门所有数据
  private getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  searchForm() {
    this.queryDataForm.pageNo = 1;
    this.getList();
  }

  resetForm() {
    this.formData = {
      receiptCode: '',
      startCheckDate: '',
      endCheckDate: '',
      inspectedUnitId: '', // 被检单位id列表
      checkBigCategory: '', // 检查大类
      checkLevel: '', // 检查级别
      checkType: '', // 检查类型
      hazardContent: '', // 检查类型
      self: false, // 与我相关
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getList();
  }

  getListData() {
    this.getList();
  }

  /**
   * desc 新增
   * */
  addCheck() {
    this.pageFlag = 1; // 新增检查单
  }

  editIt(data: any) {
    (this.$refs.EditPropRef as any).showDialog(data.id);
  }

  /**
   * desc 检查
   * */
  checkingPage(data: any) {
    this.rowId = data;
    this.pageFlag = 2; // 检查
  }

  /**
   * desc 整改单
   * */
  viewList(data: any) {
    this.rowId = data;
    this.pageFlag = 3;
  }

  /**
   * desc 详情
   * */
  showDetail(data: any) {
    this.rowId = data;
    this.pageFlag = 4;
  }

  /**
   * desc 完成
   * */
  downIt(data: any) {
    this.$confirm('是否完成安全检查任务?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        performanceServer
          .finishForm({
            taskId: data.id,
          })
          .then((res: any) => {
            if (res.code === '200') {
              this.$message.success('成功完成安全检查任务！');
              this.getList();
            } else {
              this.$message.warning(res.msg);
            }
          });
      })
      .catch(() => {
        this.$message.info('已取消完成安全检查任务。');
      });
  }

  /**
   * desc 删除
   * */
  delIt(data: any) {
    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        performanceServer.deleteTask(data.id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('成功删除该条数据');
            this.getList();
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  /**
   *  组合列表的查询参数
   */
  getListQueryParam() {
    return {
      pageNo: (this.queryDataForm as any).pageNo,
      pageSize: (this.queryDataForm as any).pageSize,
      receiptCode: this.formData.receiptCode ? this.formData.receiptCode : null,
      startCheckDate: this.formData.startCheckDate ? this.formData.startCheckDate : null,
      endCheckDate: this.formData.endCheckDate ? this.formData.endCheckDate : null,
      hazardContent: this.formData.hazardContent ? this.formData.hazardContent : null,
      self: this.formData.self,
      checkBigCategory: this.formData.checkBigCategory ? this.formData.checkBigCategory : null,
      checkLevel: this.formData.checkLevel ? this.formData.checkLevel : null,
      checkType: this.formData.checkType ? this.formData.checkType : null,
      inspectedUnitId: this.formData.inspectedUnitId,
    };
  }

  /**
   * 表格选中的变化
   */
  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }

  /**
   * 导出
   * @private
   */
  private exportExcel() {
    this.$confirm('导出安全检查隐患记录是否继续？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.exportLoading = true;
        this.exportExcelApi();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
  }

  exportExcelApi() {
    const pageSearchData: any = this.getListQueryParam();
    const _selectList = this.multipleSelection.map((item: any) => item.id);
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: serverUrl + '/api/yunnan/security-check/task/export/excel', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: {
        ...pageSearchData,
        taskIds: _selectList,
      },
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.exportLoading = false;
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }

  /**
   * @desc 通用的子页面返回 父级的方法
   * */
  backToIndex() {
    this.pageFlag = 0;
    this.getList();
  }

  hideDialogHandel() {
    this.getList();
  }
}
